/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { socialGetSocialBilibiliArchives } from "../../funcs/socialGetSocialBilibiliArchives.js";
import { GetSocialBilibiliArchivesRequest$zodSchema } from "../../models/getsocialbilibiliarchivesop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSocialBilibiliArchivesRequest$zodSchema,
};

export const tool$socialGetSocialBilibiliArchives: ToolDefinition<typeof args> =
  {
    name: "social-get-social-bilibili-archives",
    description: `查询 B站投稿

想要获取UP主的所有投稿视频？或者想在你的应用里展示创作者的作品集？这个接口能帮你轻松实现。

## 功能概述
通过用户的 \`mid\`（用户ID），你可以获取该UP主的投稿视频列表。接口支持关键词搜索、分页加载和多种排序方式，让你能够灵活地展示和分析创作者的内容。

## 参数说明
- **\`mid\` (用户ID)**: B站用户的mid，必填参数。
- **\`keywords\` (搜索关键词)**: 可选，用于在该UP主的投稿中搜索特定关键词。
- **\`orderby\` (排序方式)**: 
  - \`pubdate\`: 按最新发布排序（默认）
  - \`views\`: 按最多播放排序
- **\`ps\` (每页条数)**: 默认20条。
- **\`pn\` (页码)**: 默认1，用于分页。

## 响应体字段说明
- **\`total\` (总稿件数)**: UP主的投稿总数。
- **\`page\` (当前页码)**: 当前返回的页码。
- **\`size\` (每页数量)**: 每页返回的视频数量。
- **\`videos\` (视频列表)**: 包含当前页的所有视频信息：
  - \`aid\`: 视频的AV号
  - \`bvid\`: 视频的BV号
  - \`title\`: 视频标题
  - \`cover\`: 封面URL
  - \`duration\`: 时长（秒）
  - \`play_count\`: 播放量
  - \`publish_time\`: 发布时间戳
  - \`create_time\`: 创建时间戳
  - \`state\`: 视频状态
  - \`is_ugc_pay\`: 是否付费视频（0=免费，1=付费）
  - \`is_interactive\`: 是否为互动视频`,
    scopes: ["read"],
    annotations: {
      "title": "",
      "destructiveHint": false,
      "idempotentHint": false,
      "openWorldHint": true,
      "readOnlyHint": true,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await socialGetSocialBilibiliArchives(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
